import { PlaceModel } from '@deltager/organizers/admin/shared/models/place.model';
import { EventLocationType } from './event-location-type.enum';
import { Municipality } from '@deltager/organizers/admin/shared/components/location/municipality.model';

export class EventLocation {
  id?: 0;
  name?: string;
  venue?: string;
  address1: string;
  address2?: string;
  postcode: string;
  country: string;
  lat?: number;
  lon?: number;
  city: string;
  locationType: EventLocationType;
  municipalities: Municipality[];

  constructor(initialData?: Partial<EventLocation>) {
    Object.assign(this, initialData);
  }

  static fromPlaceModel(place: PlaceModel): EventLocation {
    return new EventLocation({
      id: 0,
      name: place.fullAddress,
      venue: place.venue,
      address1: place.address,
      address2: '',
      postcode: place.postalCode,
      country: place.country,
      lat: place.lat,
      lon: place.lon,
      city: place.city,
      locationType: EventLocationType.Physical,
    });
  }
}
